// extracted by mini-css-extract-plugin
export var sliderRange = "_nw-2";
export var sliderRoot = "_nw-0";
export var sliderThumb = "_nw-3";
export var sliderTrack = "_nw-1";